module.exports = __webpack_public_path__ + "img/pulse-sms-plus-logo-dark-bg.fdcc1ab0.png";